import React, { Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import ListingPageComponent from '../../components/ListingPageComponent.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import UI_ACTIONS from '../../data/UiActionConstants.js';
import { getApi } from '../../api/endpoints.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import UiAction from '../../components/UiAction.js';

const Index = () => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: false };
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
      disableSort: true,
    },
    {
      ...defaultHeaderConfig,
      label: 'Type',
      attr: 'addon_type',
      disableSort: true,
    },
    {
      ...defaultHeaderConfig,
      label: 'Price',
      attr: 'price',
    },
    {
      ...defaultHeaderConfig,
      label: 'Swap Count',
      attr: 'swap_count_validity',
    }, {
      ...defaultHeaderConfig,
      label: 'Validity Days',
      attr: 'time_validity',
    }, {
      ...defaultHeaderConfig,
      label: 'Description',
      attr: 'description',
      disableSort: true,
    },
    {
      disableSort: true,
      label: 'Action',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_addon.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onEditClick = (id) => {
    navigate(`/addons/${id}/edit`)
  }

  const onNewClick = () => {
    navigate(`/addons/new`)
  }

  const tableHeaderActionsComponent = () => {
    return <Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_addon.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Addon</span>
        </button>
      </UiAction>
    </Fragment>
  }

  return <ListingPageComponent
    key={PAGES.AddonsListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.AddonsListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Addons'}]}
    listingMutation={getApi('addons')}
    className="addons-listing-page"
    contentHeading="All Add Ons- Results"
    headers={headers}
    recordsKey="addons"
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
    searchBy={['ID', 'Name']}
  />
};

export default Index;
